import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/access/")({
    beforeLoad: () => {
        throw redirect({ to: "/admin/access/users", replace: true });
    },
});
